import type Tracker from "@openreplay/tracker";
import type { CheckoutEvent } from "@/api/checkoutTelemetry";

const MAX_PENDING_EVENTS = 50;
let tracker: Pick<Tracker, "event"> | undefined;
let disabled = false;
const pendingEvents: CheckoutEvent[] = [];

function sendCheckoutEvent(event: CheckoutEvent) {
  try {
    const name = [`checkout_${event.resultado}`, event.operacao, event.codigo].filter(Boolean).join(":");
    tracker?.event(name, event, event.resultado !== "sucesso");
  } catch {
    console.warn("[OpenReplay] Não foi possível registrar o resultado.");
  }
}

export function recordCheckoutEvent(event: CheckoutEvent) {
  if (!import.meta.env.PROD || disabled) return;
  if (tracker) return sendCheckoutEvent(event);
  // Retém apenas dados classificados, nunca objetos Axios ou payloads do cliente.
  if (pendingEvents.length === MAX_PENDING_EVENTS) pendingEvents.shift();
  pendingEvents.push(event);
}

export function connectCheckoutEvents(instance: Pick<Tracker, "event">) {
  if (disabled) return;
  tracker = instance;
  pendingEvents.splice(0).forEach(sendCheckoutEvent);
}

export function disableCheckoutEvents() {
  disabled = true;
  tracker = undefined;
  pendingEvents.length = 0;
}
